import { useQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { retryUnlessClientError } from '~/shared/lib/api-error'
import { GOLD_SET_QUERY_KEYS } from '../config'
import type { GoldSetCategories } from '../model'

export function useGoldSetCategories() {
  return useQuery({
    queryKey: GOLD_SET_QUERY_KEYS.categories(),
    queryFn: async () => {
      const response = await apiClient.client.get({
        url: '/gold-set/categories',
        throwOnError: true,
      })
      return response.data as GoldSetCategories
    },
    staleTime: 60 * 60 * 1000,
    retry: retryUnlessClientError,
  })
}
